export default "__VITE_ASSET__697000a6__"